import { RouteName } from '../constants/routeNames';
import type { RouteDefinition } from '../types';

export const childOrganizationRoutes = (t: (key: string) => string): RouteDefinition[] => [
  {
    path: '/child-organizations',
    name: RouteName.ChildOrganizationsList,
    component: () => import('../../views/child-organizations/ChildOrganizationsList.vue'),
    meta: { requiresAuth: true, title: t('childOrganizations.contextHeaderLabel') }
  },
  {
    path: '/child-organizations/active',
    name: RouteName.ChildOrganizationsActiveReports,
    component: () => import('../../views/ReportsPage.vue'),
    meta: { requiresAuth: true, key: 'childOrganizationsActiveReports', title: t('childOrganizations.contextHeaderActiveReportsLabel') }
  },
  {
    path: '/child-organizations/historic',
    name: RouteName.ChildOrganizationsHistoricReports,
    component: () => import('../../views/ReportsPage.vue'),
    meta: { requiresAuth: true, key: 'childOrganizationsHistoricReports', title: t('childOrganizations.contextHeaderHistoricReportsLabel') }
  }
];
